<template>
	<div class="card">
		<div class="card-header">
			Izin Presensi
			<el-tooltip placement="right" content="Lihat data izin presensi">
				<el-button link type="primary" tag="router-link" to="izin">
					<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
				</el-button>
			</el-tooltip>
		</div>
		<div class="card-body row align-items-center" v-loading="loading">
			<span class="col-auto mx-auto" v-if="loading">Memuat...</span>
			<span class="col-auto mx-auto" v-else-if="!izinCounts.length">Data tidak ditemukan</span>
			<el-descriptions :column="1" border v-else>
				<el-descriptions-item v-for="ic in izinCounts" :key="`${ic.tahun}_${ic.bulan}`" :label="ic.bulan_tahun" label-align="right">
					<div class="hstack gap-1">
						<transition name="slide-up" mode="out-in">
							<span class="fs-5" :key="ic.jumlah">{{ ic.jumlah }}</span>
						</transition>
						<span>data izin</span>
					</div>
				</el-descriptions-item>
			</el-descriptions>
		</div>
	</div>
</template>

<script>
export default {
	name: "IzinPresensi",
	data() {
		return {
			izinCounts: [],
			loading: true,
		};
	},
	mounted() {
		this.$ws.main.on("izin:inserted", this.insertedIzin);
		this.$ws.main.on("izin:updated", this.updatedIzin);
		this.$ws.main.on("izin:deleted", this.deletedIzin);
		this.getJumlahIzinPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("izin:inserted");
		this.$ws.main.off("izin:updated");
		this.$ws.main.off("izin:deleted");
	},
	methods: {
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		insertedIzin(data) {
			const newTanggal = this.toWIB(data.tanggal);
			const newTahun = newTanggal.getFullYear();
			const newBulan = newTanggal.getMonth() + 1;

			const existIndex = this.izinCounts.findIndex((ic) => ic.tahun === newTahun && ic.bulan === newBulan);

			if (existIndex !== -1) {
				this.izinCounts[existIndex].jumlah = this.izinCounts[existIndex].jumlah + 1;

				return;
			}

			const temp = [...this.izinCounts];

			const newData = {
				tahun: newTahun,
				bulan: newBulan,
				jumlah: 1,
				bulan_tahun: new Date(newTanggal).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
			};

			temp.push(newData);

			temp.sort((a, b) => {
				return b.tahun - a.tahun || b.bulan - a.bulan;
			});

			const newIndex = temp.findIndex((t) => t.tahun === newTahun && t.bulan === newBulan);

			if (newIndex === 12) return;

			this.izinCounts.splice(newIndex, 0, newData);

			if (this.izinCounts.length > 12) this.izinCounts.pop();
		},
		updatedIzin(data) {
			const oldTanggal = this.toWIB(data.old_izin_presensi.tanggal);
			const newTanggal = this.toWIB(data.new_izin_presensi.tanggal);

			if (oldTanggal.getMonth() === newTanggal.getMonth() && oldTanggal.getFullYear() === newTanggal.getFullYear()) return;

			const oldTahun = oldTanggal.getFullYear();
			const oldBulan = oldTanggal.getMonth() + 1;

			const oldIndex = this.izinCounts.findIndex((ic) => ic.tahun === oldTahun && ic.bulan === oldBulan);

			if (oldIndex !== -1) {
				if (this.izinCounts[oldIndex].jumlah === 1) this.izinCounts.splice(oldIndex, 1);
				else this.izinCounts[oldIndex].jumlah = this.izinCounts[oldIndex].jumlah - 1;
			}

			const newTahun = newTanggal.getFullYear();
			const newBulan = newTanggal.getMonth() + 1;

			const newIndex = this.izinCounts.findIndex((ic) => ic.tahun === newTahun && ic.bulan === newBulan);

			if (newIndex !== -1) {
				this.izinCounts[newIndex].jumlah = this.izinCounts[newIndex].jumlah + 1;
			} else {
				const temp = [...this.izinCounts];

				const newData = {
					tahun: newTahun,
					bulan: newBulan,
					jumlah: 1,
					bulan_tahun: new Date(newTanggal).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
				};

				temp.push(newData);

				temp.sort((a, b) => {
					return b.tahun - a.tahun || b.bulan - a.bulan;
				});

				const newDataIndex = temp.findIndex((t) => t.tahun === newTahun && t.bulan === newBulan);

				if (newDataIndex === 12) return;

				this.izinCounts.splice(newDataIndex, 0, newData);

				if (this.izinCounts.length > 12) this.izinCounts.pop();
			}
		},
		deletedIzin(data) {
			const oldTanggal = this.toWIB(data.old_izin_presensi.tanggal);
			const oldTahun = oldTanggal.getFullYear();
			const oldBulan = oldTanggal.getMonth() + 1;

			const existIndex = this.izinCounts.findIndex((ic) => ic.tahun === oldTahun && ic.bulan === oldBulan);

			if (existIndex !== -1) {
				if (this.izinCounts[existIndex].jumlah === 1) this.izinCounts.splice(existIndex, 1);
				else this.izinCounts[existIndex].jumlah = this.izinCounts[existIndex].jumlah - 1;
			}
		},
		async getJumlahIzinPresensi() {
			try {
				const { data } = await this.$defaultApi.get("/izin/count/month");

				const izin = data.data.izin_presensi_counts.map((i) => ({
					...i,
					bulan_tahun: new Date(i.tahun, i.bulan - 1, 1).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
				}));

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.izinCounts = izin;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped></style>
